module.exports = __webpack_public_path__ + "img/factor_c_blue.1f7483a6.svg";